import React, { useEffect, useState } from 'react';
import { Row, Col, Input, Button, Alert, Container, Label } from "reactstrap";
import { v4 as uuidv4 } from 'uuid';
import { Link, useNavigate } from 'react-router-dom';
import "../../assets/css/--component-authentication.css"
// import images
import googleLogo from "../../assets/images/google.png";
import logo from "../../assets/images/logo.png";
import authBanner from "../../assets/images/Login_Picture.png";
import { postLogin, postVerifyEmailOTP, sendOTPCode, postVerifyMfaLogin, postRecoverMfa } from '../../helper/api-methods';
import { useGoogleLogin, GoogleLogin } from '@react-oauth/google';
import { showToast } from '../../components/Toast';
import OtpInput from 'react-otp-input';
import MfaSetupPanel from '../../components/MfaSetupPanel';

function Login() {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({ username: "", password: "", apiError: "" });
    const [currentTab, setCurrentTab] = useState(1);
    const [otp, setOtp] = useState("");
    const [authToken, setAuthToken] = useState("");
    const [userId, setUserId] = useState("");
    const [timer, setTimer] = useState(60);
    const [canResend, setCanResend] = useState(false);
    const [mfaLoginToken, setMfaLoginToken] = useState("");
    const [mfaCode, setMfaCode] = useState("");
    const [mfaSubView, setMfaSubView] = useState("code");
    const [recoveryCode, setRecoveryCode] = useState("");
    const [reenrollData, setReenrollData] = useState(null);
    const [rememberDevice, setRememberDevice] = useState(false);
    document.title = "Wiserep";
    const history = useNavigate();

    useEffect(() => {
        let interval;
        if (currentTab === 2 && timer > 0) {
            interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);
        } else if (timer === 0) {
            setCanResend(true);
        }

        return () => clearInterval(interval);
    }, [currentTab, timer]);



    const validateGoogleLogin = (credentials) => {
        setLoading(true)
        postLogin("/auth/google", { accessToken: credentials }).then((data) => {
            localStorage.setItem("authToken", data.token)
            localStorage.setItem("userName", data.userObj.username)
            localStorage.setItem("userId", data.userObj._id)
            // localStorage.setItem("user", JSON.stringify({ name: data.fullName, picture: data.profilePictureUrl }))
            if (data.userObj.isTrialUser && !data.userObj.getting_started.isCompleted) {
                history('/get-started');
            }
            else {
                history('/');
            }
        }).catch((e) => {
            console.log(e)
            // resetForm();
            setLoading(false)
        })
    }

    const formatRecoveryCodeInput = (raw) => {
        const clean = raw.replace(/[^a-zA-Z0-9]/g, '').toUpperCase().slice(0, 8);
        return clean.length > 4 ? `${clean.slice(0, 4)}-${clean.slice(4)}` : clean;
    }

    const completeLogin = (accessToken, user) => {
        localStorage.setItem("authToken", accessToken)
        localStorage.setItem("userName", user.username)
        localStorage.setItem("userId", user._id)
        if (user.isTrialUser && !user.getting_started.isCompleted) {
            history('/get-started');
        } else {
            history('/');
        }
    }

    const sendEmailHandler = async () => {
        setLoading(true);
        try {
            const data = await sendOTPCode("/otp/signup-email", { username: username });
            if (data.message === "OTP sent successfully") {
                showToast("success", "OTP Sent", "Please check your mail for the OTP.");
                setLoading(false);
                return true;
            } else {
                showToast("error", "Error", data.message);
                setLoading(false);
                return false;
            }
        } catch (e) {
            console.log("error", e);
            setLoading(false);
            return false;
        }
    }

    const verifyEmailHandler = () => {
        return postVerifyEmailOTP("/otp/verify", { otp: Number(otp), username: username })
            .then((data) => {
                if (data.success) {
                    completeLogin(authToken, data.data);
                }
                else {
                    showToast("error", "OTP Verification Failed", "We could not verify the OTP you provided. Please check the OTP and try again.");
                }
            })
            .catch((e) => {
                console.log("error", e);
                return false;
            });
    }

    const verifyMfaLoginHandler = () => {
        if (!mfaCode || mfaCode.length < 6) {
            showToast("error", "Invalid Code", "Please enter the 6-digit code from your authenticator app.");
            return;
        }
        setLoading(true);
        postVerifyMfaLogin("/auth/mfa/login/verify", { mfaLoginToken, code: mfaCode, rememberDevice }).then((data) => {
            setLoading(false);
            if (data.deviceToken) {
                localStorage.setItem('mfaDeviceToken:' + username.toLowerCase(), data.deviceToken);
            }
            completeLogin(data.accessToken, data.user);
        }).catch((e) => {
            setLoading(false);
            showToast("error", "Verification Failed", e);
        });
    }

    const recoverMfaHandler = () => {
        if (!recoveryCode.trim()) {
            showToast("error", "Invalid Code", "Please enter one of your recovery codes.");
            return;
        }
        setLoading(true);
        postRecoverMfa("/auth/mfa/recover", { mfaLoginToken, recoveryCode: recoveryCode.trim() }).then((data) => {
            setLoading(false);
            setReenrollData(data);
            setMfaSubView("reenroll");
        }).catch((e) => {
            setLoading(false);
            showToast("error", "Recovery Failed", e);
        });
    }

    const backToCredentials = () => {
        setCurrentTab(1);
        setMfaLoginToken("");
        setMfaCode("");
        setMfaSubView("code");
        setRecoveryCode("");
        setReenrollData(null);
        setRememberDevice(false);
    }

    const validateSubmit = (e) => {
        e.preventDefault();
        resetErrors();
        const error = { username: "", password: "", apiError: "" }
        let flag = false;
        if (!username || username.replaceAll(/\s/g, '').length < 3 || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(username)) {
            error.username = 'Please provide a valid email address';
            flag = true
        }
        if (!password || password.replaceAll(/\s/g, '').length < 6) {
            error.password = 'Please provide a valid password';
            flag = true
        }
        setErrors(error);
        if (!flag) {
            setLoading(true)
            const deviceToken = localStorage.getItem('mfaDeviceToken:' + username.toLowerCase()) || undefined;
            postLogin("/auth/signin", { username: username, password: password, deviceToken }).then((data) => {
                if (data.mfaRequired) {
                    setLoading(false);
                    setMfaLoginToken(data.mfaLoginToken);
                    setMfaCode("");
                    setMfaSubView("code");
                    setRecoveryCode("");
                    setReenrollData(null);
                    setRememberDevice(false);
                    setCurrentTab(3);
                    return;
                }
                setAuthToken(data.accessToken);
                setUserId(data.user._id);
                if (data.user.isVerified) {
                    completeLogin(data.accessToken, data.user);
                }
                else {
                    setAuthToken(data.accessToken);
                    setUserId(data.user._id);
                    sendEmailHandler().then((emailResponse) => {
                        if (emailResponse) {
                            setCurrentTab(2);
                            setOtp("");
                            setTimer(60);
                            setCanResend(false);
                        } else {
                            showToast("error", "OTP Failed", 'Failed to send OTP to the provided email. Please try again.');
                        }
                    });
                }
            }).catch((e) => {
                const error = { username: "", password: "", apiError: e }
                setErrors(error);
                // resetForm();
                setLoading(false)
            })
        }
    }

    const resetForm = () => {
        setUsername("");
        setPassword("");
    }
    const resetErrors = () => {
        const error = { username: "", password: "", apiError: "" }
        setErrors(error);
    }

    const handleResendOTP = async () => {
        setTimer(60);
        setCanResend(false);
        setOtp("");
        await sendEmailHandler();
    };

    return (
        <div>
            <Container fluid className="p-0">
                <Row className="g-0">
                    <Col lg={6} className='my-auto'>
                        <div className='mx-auto login-section'>
                            {errors.apiError ? <Alert color="danger">{errors.apiError}</Alert> : null}
                            <div className="p-2 my-auto">
                                {
                                    currentTab === 1 ?
                                        <form className="form-horizontal" onSubmit={validateSubmit}>
                                            <div className='text-center'>
                                                <Link to="/" className="">
                                                    <img src={logo} alt="" height="60" className="auth-logo mx-auto" />
                                                </Link>
                                                <h3 className="fs-34 fw-500 mt-2 text-dark">Log in to your Account</h3>
                                                <p className="text-muted-200 p-0 mb-4 m-0">Welcome back!</p>
                                            </div>
                                            <div className="auth-form-group-custom mb-2 position-relative">
                                                <Input name="username" value={username} onChange={(e) => { setUsername(e.target.value) }} type="text" className={`ps-2 form-control text-gray-100 login-input ${errors.userName ? "is-invalid" : ""}`} id="username" placeholder="Email Address" />
                                                {/* <i className="ri-search-line fs-16 position-absolute text-muted top-50 translate-middle-y ms-2 bg-white rounded"></i> */}
                                            </div>
                                            {errors.username ? <div className="invalid-feedback mb-3 mt-0">{errors.username}</div> : null}
                                            <div className="auth-form-group-custom mb-2 position-relative">
                                                <Input id="password" name="password" value={password} onChange={(e) => { setPassword(e.target.value) }} type={showPassword ? "text" : "password"} className={`form-control login-input ${errors.password ? "is-invalid" : ""}`} placeholder="Password" />
                                                <i
                                                    className={`ri-${showPassword ? "eye-off" : "eye"}-line show-hide-password-icon`}
                                                    onClick={() => setShowPassword((prev) => !prev)}
                                                ></i>
                                            </div>
                                            {errors.password ? <div className="invalid-feedback mb-3 mt-0">{errors.password}</div> : null}
                                            <div className="mt-4 text-center">
                                                <Button disabled={loading} type='submit' className="btn-lg w-100 linear-gradient-btn">{loading ? "Please Wait" : "Continue"}</Button>
                                            </div>
                                            {/* Flex rather than a 6/6 grid: at the narrower 440px form
                                                width each column was ~190px, which wrapped the longer
                                                link onto a second line. Copy also shortened to match
                                                the brand's "short sentences" voice. */}
                                            <div className="mt-3 d-flex justify-content-between align-items-center gap-3">
                                                <Link to="/signup" className="text-gray-200">New here? Sign up</Link>
                                                <Link to="/forgot-password" className="text-gray-200">Forgot password?</Link>
                                            </div>
                                        </form>
                                        : currentTab === 2 ?
                                        <>
                                            <div className='text-center'>
                                                <h3 className="fs-34 fw-500 mt-2 text-dark">Verify your Account</h3>
                                                <p className="text-gray-200 p-0 mb-4 m-0">Provide OTP sent to <span className="fw-500">{username}</span></p>
                                            </div>
                                            <div className="d-flex justify-content-center gap-2 mb-4">
                                                <OtpInput
                                                    value={otp}
                                                    onChange={setOtp}
                                                    numInputs={6}
                                                    shouldAutoFocus={true}
                                                    renderSeparator={<span> </span>}
                                                    renderInput={(props) => <input {...props} />}
                                                    inputStyle={{ width: "60px", height: "60px", borderRadius: "7px", border: "none", backgroundColor: "#f1f1f1", fontSize: "20px" }}
                                                    containerStyle={"otp-input"}

                                                />
                                            </div>
                                            <Row>
                                                <Col md={6}>
                                                    <div className="mt-2 text-left">
                                                        {canResend ? (
                                                            <Link className="text-gray-200" onClick={handleResendOTP}>
                                                                Didn't receive the email? Resend OTP
                                                            </Link>
                                                        ) : (
                                                            <span className="text-primary">
                                                                Resend OTP in <span className="fw-600">{String(Math.floor(timer / 60)).padStart(2, '0')}:{String(timer % 60).padStart(2, '0')}</span>
                                                            </span>
                                                        )}
                                                    </div>
                                                </Col>
                                                <Col md={6}>
                                                    <div className="mt-2 text-right">
                                                        <Link onClick={() => setCurrentTab(1)} className="text-gray-200">Use another email? Go Back</Link>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={12} className='text-center'>
                                                    <div className="mt-4 text-center">
                                                        <Button disabled={loading} onClick={() => { verifyEmailHandler() }} className="btn-lg w-100 linear-gradient-btn">{loading ? "Please Wait" : "Login"}</Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </>
                                        : mfaSubView === "reenroll" ?
                                        <MfaSetupPanel
                                            qrCodeDataUrl={reenrollData?.qrCodeDataUrl}
                                            manualEntryKey={reenrollData?.manualEntryKey}
                                            mfaSetupToken={reenrollData?.mfaSetupToken}
                                            title="Set up your new Authenticator"
                                            description="Your account is recovered. Scan this QR code with an authenticator app, then enter the 6-digit code it shows to finish."
                                            onVerified={(data) => completeLogin(data.accessToken, data)}
                                            onExpiredAction={backToCredentials}
                                        />
                                        : mfaSubView === "recovery" ?
                                        <>
                                            <div className='text-center'>
                                                <h3 className="fs-34 fw-500 mt-2 text-dark">Use a Recovery Code</h3>
                                                <p className="text-gray-200 p-0 mb-4 m-0">Enter one of the recovery codes you saved when you set up your authenticator</p>
                                            </div>
                                            <div className="auth-form-group-custom mb-2 position-relative">
                                                <Input name="recoveryCode" value={recoveryCode} onChange={(e) => setRecoveryCode(formatRecoveryCodeInput(e.target.value))} type="text" className="form-control login-input" placeholder="XXXX-XXXX" />
                                            </div>
                                            <Row>
                                                <Col md={12}>
                                                    <div className="mt-2 text-right">
                                                        <Link onClick={() => setMfaSubView("code")} className="text-gray-200">Back</Link>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={12} className='text-center'>
                                                    <div className="mt-4 text-center">
                                                        <Button disabled={loading} onClick={() => { recoverMfaHandler() }} className="btn-lg w-100 linear-gradient-btn">{loading ? "Please Wait" : "Recover Access"}</Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </>
                                        :
                                        <>
                                            <div className='text-center'>
                                                <h3 className="fs-34 fw-500 mt-2 text-dark">Two-Factor Authentication</h3>
                                                <p className="text-gray-200 p-0 mb-4 m-0">Enter the 6-digit code from your authenticator app</p>
                                            </div>
                                            <div className="d-flex justify-content-center gap-2 mb-4">
                                                <OtpInput
                                                    value={mfaCode}
                                                    onChange={setMfaCode}
                                                    numInputs={6}
                                                    shouldAutoFocus={true}
                                                    renderSeparator={<span> </span>}
                                                    renderInput={(props) => <input {...props} />}
                                                    inputStyle={{ width: "60px", height: "60px", borderRadius: "7px", border: "none", backgroundColor: "#f1f1f1", fontSize: "20px" }}
                                                    containerStyle={"otp-input"}
                                                />
                                            </div>
                                            <div className="form-check mb-2">
                                                <Input
                                                    type="checkbox"
                                                    id="rememberDevice"
                                                    checked={rememberDevice}
                                                    onChange={(e) => setRememberDevice(e.target.checked)}
                                                    className="form-check-input"
                                                />
                                                <label className="form-check-label ms-1" htmlFor="rememberDevice">
                                                    Remember this device and skip 2FA next time
                                                </label>
                                            </div>
                                            <Row>
                                                <Col md={6}>
                                                    <div className="mt-2 text-left">
                                                        <Link onClick={() => setMfaSubView("recovery")} className="text-gray-200">Lost access to your authenticator?</Link>
                                                    </div>
                                                </Col>
                                                <Col md={6}>
                                                    <div className="mt-2 text-right">
                                                        <Link onClick={backToCredentials} className="text-gray-200">Go Back</Link>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={12} className='text-center'>
                                                    <div className="mt-4 text-center">
                                                        <Button disabled={loading} onClick={() => { verifyMfaLoginHandler() }} className="btn-lg w-100 linear-gradient-btn">{loading ? "Please Wait" : "Verify"}</Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </>
                                }
                                {/* <div className="mt-4 d-flex justify-content-center align-items-center">
                                    <span className="w-100 login-separator"></span>
                                    <span className='w-100 text-center continue-with'>Or continue with</span>
                                    <span className='w-100 login-separator'></span>
                                </div> */}
                                {/* <div className="mt-4 text-center">
                                    <Button disabled={loading} className="btn-lg w-100 font-normal" style={{ background: "#0976B4", border: "none", display: "flex", justifyContent: "center", alignItems: "center", columnGap: "10px" }}><img src={linkedInLogo} width={30} height={30} /> Sign in with Linkedin</Button>
                                </div> */}
                                {/* <div className="mt-3 text-center">
                                    <Button disabled={loading} onClick={() => login()} className="btn-lg w-100 text-black font-normal" style={{ background: "transparent", border: "1px solid #ddd", display: "flex", justifyContent: "center", alignItems: "center", columnGap: "10px" }}><img src={googleLogo} width={30} height={30} /> Sign in with Google</Button>
                                </div> */}
                                {/* <div className="mt-3 text-center w-35 ms-auto me-auto">
                                    <GoogleLogin
                                        onSuccess={async (credentialResponse) => {
                                            try {
                                                validateGoogleLogin(credentialResponse.credential)
                                            } catch (err) {
                                                console.error(err);
                                            }
                                        }}
                                        onError={() => {
                                            console.log("Login Failed");
                                        }}
                                    />
                                </div> */}
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} className="d-none d-lg-block p-0">
                            {/* Aurora panel. Composed entirely in CSS so it tracks the
                                brand tokens — the previous raster banner was baked in the
                                old palette and could never be rebranded. */}
                            <div className="auth-aurora">
                                <span className="auth-aurora__eyebrow">
                                    <i className="ri-shield-check-line" /> Enterprise-ready
                                </span>
                                <h2 className="auth-aurora__title">Voice AI, delivered.</h2>
                                <p className="auth-aurora__sub">
                                    Build, launch and measure AI phone agents — outbound campaigns,
                                    live transcripts and conversion analytics in one place.
                                </p>
                                <div className="auth-aurora__frame">
                                    <img src={authBanner} alt="" />
                                </div>
                            </div>
                        </Col>
                </Row>
            </Container>
        </div>

    );

}


export default Login